import { useMutation } from '@tanstack/react-query'
import { apiClient } from '@/lib/api-client'
import { supabase } from '@/lib/supabase'

export function useDeleteAccount() {
  return useMutation({
    mutationFn: async () => {
      const result = await apiClient.delete<unknown>('/api/v1/account')
      await supabase.auth.signOut()
      return result
    },
  })
}
